import React, {useEffect} from 'react'
import {Link} from 'react-router-dom'

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }) 
  return (
    <div>
      <header className="header_default">
          <div className="header_content">
            <h1 className="white-text">Page Not Found</h1>
          </div>
        </header>

        <main className="container">
          <h2>Sorry, we can't find that page.</h2>
          <Link to="/" className="btn deep-orange lighten-1">Return to Home page</Link>
        </main>

        <br />
    </div>
  )
}

export default NotFound